"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Project = void 0;
var create_entity_1 = require("../../utils/create-entity");
var gql = String.raw;
exports.Project = {
  name: 'Project',
  label: 'Project',
  components: {},
  pluralLabel: 'Projects',
  useSpaces: true,
  useSlices: true,
  autoRoutes: ['create', 'update', 'list'],
  card: {},
  list: {
    queryFields: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      type { id name slug }\n      status { id name slug }\n      team { id name slug description { id text } }\n      description { id text }\n      links { id name slug }\n      documents { id name slug }\n    "], ["\n      type { id name slug }\n      status { id name slug }\n      team { id name slug description { id text } }\n      description { id text }\n      links { id name slug }\n      documents { id name slug }\n    "])))
  },
  form: {
    queryFields: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      teams: allTeams { id name slug description { id text(truncate: { words: 50 }) } roles { role { id name } person { id name slug photo { id url thumbnails { id full { id url width height } } } } } }\n      statuses: allProjectStatuses { id name slug }\n      documents: allDocuments { id name slug description { id text } }\n      projects: allProjects { id name slug }\n      links: allLinks { id name slug }\n      keyIssues: allKeyIssues { id name slug }\n      challenges: allChallenges { id name slug }\n    "], ["\n      teams: allTeams { id name slug description { id text(truncate: { words: 50 }) } roles { role { id name } person { id name slug photo { id url thumbnails { id full { id url width height } } } } } }\n      statuses: allProjectStatuses { id name slug }\n      documents: allDocuments { id name slug description { id text } }\n      projects: allProjects { id name slug }\n      links: allLinks { id name slug }\n      keyIssues: allKeyIssues { id name slug }\n      challenges: allChallenges { id name slug }\n    "]))),
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      parent: {
        type: 'parent',
        description: 'Is this {{PROJECT}} part of another {{PROJECT}}?'
      },
      team: {
        type: 'linked',
        entityTypeName: "Team"
      },
      status: {
        type: 'linked',
        entityTypeName: "ProjectStatus",
        description: 'How far along is this {{PROJECT}}?'
      },
      documents: {
        type: 'linked',
        entityTypeName: "Document"
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: "Link"
      }
    })
  }
};
var templateObject_1, templateObject_2;